export default {
    methods: {
        getCommunityBaseUrl(community) {
            return `${location.protocol}//${community.slug}.${this.$store.state.config.app.domain}`;
        },
        loginToCommunity(community) {
            window.open(
                `${this.getCommunityBaseUrl(community)}/home`,
                "_blank"
            );
        },
    },
};
